exports = module.exports = require("../../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "[data-v-122b7f56] .el-divider--horizontal{margin:0;margin-bottom:10px;opacity:.1}", ""]);

// exports
